import { Navigate } from 'react-router-dom';
import { useAuth } from '../presentation/hooks/useAuth';


const PublicRoute = ({ children }) => {
  const { user, loading, authChecked } = useAuth();

  // Still checking authentication
  if (loading || !authChecked) {
    return (
      <div className="flex h-screen items-center justify-center bg-bg-main">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-primary-cyan border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-400">Loading...</p>
        </div>
      </div>
    );
  }

  // Already authenticated - redirect to dashboard
  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  // Not authenticated - show login/register page
  return children;
};

export default PublicRoute;